var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "plan-content pricing-wrapper" },
    [
      _c("div", { staticClass: "container-title" }, [
        _c("div", { staticClass: "left" }, [
          _c("h2", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("dash.plan.upgrade"))),
          ]),
          _c(
            "p",
            [
              _c("router-link", { attrs: { to: "/dash/settings/billing" } }, [
                _c("a", [_vm._v(_vm._s(_vm.$t("dash.plan.subtitle")))]),
              ]),
              _vm._v(
                "\n        / " +
                  _vm._s(_vm.$t("dash.plan.upgrade")) +
                  "\n      "
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("router-link", { attrs: { to: "/dash/settings/billing" } }, [
              _c("div", { staticClass: "btn-outline-primary" }, [
                _vm._v(_vm._s(_vm.$t("dash.button.cancel"))),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "btn-primary", on: { click: _vm.beContacted } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("dash.plan.contact_me")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content-plan" }, [
        _c(
          "div",
          { staticClass: "pricing-container" },
          [
            _c(
              "section",
              { staticClass: "hide-scrollbar", attrs: { id: "configurator" } },
              [
                _c("header", { staticClass: "header" }, [
                  _c("h1", [
                    _vm._v(_vm._s(_vm.$t("dash.plan.simulation_title"))),
                  ]),
                  _c("p", { staticClass: "subtitle" }, [
                    _vm._v(_vm._s(_vm.$t("dash.plan.simulation_subtitle"))),
                  ]),
                ]),
                _c("PeriodSelector", {
                  attrs: { "selected-period": _vm.pricingState.period },
                  on: { "period-change": _vm.onPeriodChange },
                }),
                _c(
                  "div",
                  { staticClass: "sliders-container" },
                  _vm._l(_vm.sliderControls, function (control) {
                    return _c("ControlSlider", {
                      key: control.key,
                      attrs: {
                        label: control.label,
                        icon: control.icon,
                        value: _vm.pricingState[control.key],
                        "scale-name": control.scale,
                        "unique-id": control.key,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onValueChange(control.key, $event)
                        },
                      },
                    })
                  }),
                  1
                ),
                _vm.currentPlan
                  ? _c(
                      "p",
                      {
                        staticClass: "cancel-plan",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.cancelSubscriptionModal.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("dash.plan.cancel_subscription")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("ResultCard", {
              attrs: {
                result: _vm.selectedPlan,
                environment: _vm.environment,
                "is-current-plan": _vm.isCurrentPlan,
              },
              on: {
                subscribe: _vm.startSubscription,
                contact: _vm.beContacted,
              },
            }),
          ],
          1
        ),
      ]),
      _c("SubscriptionLoader", { attrs: { show: _vm.loaders.subscription } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }